import React from "react";
import Linkedin from "../../assets/linkedin.png";
import Github from "../../assets/github.png";
import Medium from "../../assets/medium.png";
const Footer = () => {
  return (
    <div className="layout pb-12">
      <div className="flex justify-center items-center gap-8">
        <a href="https://github.com/eyujunior" rel="noreferrer" target="_blank">
          <img className="h-6" src={Github} alt="github" />
        </a>
        <a
          href="https://www.linkedin.com/in/eyobel-kirub-3bb011192/"
          rel="noreferrer"
          target="_blank"
        >
          <img className="h-8" src={Linkedin} alt="linkedin" />
        </a>
        <a
          href="https://medium.com/@eyujunior"
          rel="noreferrer"
          target="_blank"
        >
          <img className="h-6" src={Medium} alt="medium" />
        </a>
      </div>
      <p className="text-N70 text-center my-8 capitalize sm:text-xl font-light">
        handcrafted by me{" "}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://www.linkedin.com/in/eyobel-kirub-3bb011192/"
        >
          @Eyobelkirub
        </a>
      </p>
    </div>
  );
};

export default Footer;
